import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { SelectionBar } from "@/components/site/SelectionBar";
import { Marquee } from "@/components/site/Marquee";
import { Pricing } from "@/components/site/Pricing";
import { Configurator } from "@/components/site/Configurator";
import { Manifesto } from "@/components/site/Manifesto";
import { ExperienceJourney } from "@/components/site/ExperienceJourney";
import { Seasons } from "@/components/site/Seasons";
import { Gallery } from "@/components/site/Gallery";
import { InquiryForm } from "@/components/site/InquiryForm";
import { ContactFooter } from "@/components/site/Footer";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";

export default function Home() {
  // Lenis lives here, not in App: the admin needs native scrolling — smooth
  // momentum fights sticky bars and long forms there.
  useSmoothScroll();
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <SelectionBar />
      <Marquee />
      {/* Rates come before the storytelling: visitors arrive asking the price. */}
      <Pricing />
      <Configurator />
      <ExperienceJourney />
      <Seasons />
      <Gallery />
      <Manifesto />
      <InquiryForm />
      <ContactFooter />
    </main>
  );
}
